export default __webpack_public_path__ + "static/media/tab-connect-participants.36371b46.png";